export { default } from './RelatedCarousel';
